import { DETERMINAR_PAGINA_ATUAL_CTE_OS } from '../../actions/types'

const initialState = undefined

export default function reducerPaginaAtualCteOs(state = 1, action = initialState) {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_CTE_OS: {
      return action.payload
    }

    default:
      return state
  }
}